// hooks/useCampuses.js
import { useSelector } from "react-redux";
import { selectDistrictData } from "store/slices";
import { useGetCampusesQuery } from "store/api";
import useQueryLoader from "./useQueryLoader";

const NO_CAMPUSES = [];

/**
 * All campuses of the open district (every page). Cached by RTK Query, but
 * refetched on mount because campuses change from several screens.
 * Not requested during onboarding (the user's own campuses are used there).
 * `hasMore` stays true until the whole list has loaded (false after an error).
 */
const useCampuses = ({ isOnboarding = false } = {}) => {
  const { id } = useSelector(selectDistrictData);
  const { data, isFetching, isError, error } = useGetCampusesQuery(id, {
    skip: !id || isOnboarding,
    refetchOnMountOrArgChange: true,
  });
  useQueryLoader(isFetching);

  return {
    loader: isFetching,
    campusesData: data ?? NO_CAMPUSES,
    error,
    hasMore: !isOnboarding && data === undefined && !isError,
  };
};

export default useCampuses;
